// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"d69e1bf8","322":"35893391","453":"dd181ba9","462":"27ed3510","491":"14c533b0","745":"682f0839","764":"bd1d3700","825":"02c7550c","963":"ec18b61a","977":"faf4c2cd"}[chunkId] + ".chunk.js";
};